import { render } from "./CatSubCategoryModal.vue?vue&type=template&id=117c9240&scoped=true"
import script from "./CatSubCategoryModal.vue?vue&type=script&lang=js"
export * from "./CatSubCategoryModal.vue?vue&type=script&lang=js"

import "./CatSubCategoryModal.vue?vue&type=style&index=0&id=117c9240&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117c9240"]])

export default __exports__